import { Button, Container, Stack } from "@mui/material";
import MHidden from "../@material-extend/MHidden";
import { useState } from "react";
import { TransactionHistoryModal } from "./TransactionHistoryModal";
import { BankAccounts } from "./BankAccounts";

export const PaymentComp = () => {
  const [txnHistoryModal, setTxnHistoryModal] = useState(false);
  const [accountDetailsModal, setAccountDetailsModal] = useState(false);

  return (
    <Container>
      <MHidden width="smDown">
        <Stack spacing={2} direction="row">
          <Button
            variant="contained"
            color="success"
            sx={{
              width: "100%",
              padding: "12px 0",
              bgcolor: "white",
              color: "black",
              "&:hover": {
                bgcolor: "grey.300",
              },
            }}
            onClick={() => setAccountDetailsModal(true)}
          >
            Pay Due
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              width: "100%", // Full width for mobile
              padding: "12px 0", // Added vertical padding
              borderColor: "white",
              color: "white",
              "&:hover": {
                borderColor: "grey.300",
              },
            }}
            onClick={() => setTxnHistoryModal(true)}
          >
            Transaction History
          </Button>
        </Stack>
      </MHidden>
      <MHidden width="smUp">
        <Stack spacing={1} direction="column">
          <Button
            variant="contained"
            color="success"
            sx={{
              width: "100%",
              padding: "12px 0",
              bgcolor: "white",
              color: "black",
              touchAction: "manipulation",
              "&:hover": {
                bgcolor: "grey.300",
              },
              "&:focus": {
                outline: "none",
                bgcolor: "grey.200",
              },
            }}
            onClick={() => setAccountDetailsModal(true)}
          >
            Pay Due
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              width: "100%",
              padding: "12px 0",
              borderColor: "white",
              color: "white",
              touchAction: "manipulation",
              "&:hover": {
                borderColor: "grey.300",
              },
              "&:focus": {
                outline: "none",
                borderColor: "grey.200",
              },
            }}
            onClick={() => setTxnHistoryModal(true)}
          >
            Transaction History
          </Button>
        </Stack>
      </MHidden>

      {txnHistoryModal && (
        <TransactionHistoryModal
          isOpen={txnHistoryModal}
          onClose={() => setTxnHistoryModal(false)}
        />
      )}
      {accountDetailsModal && (
        <BankAccounts
          open={accountDetailsModal}
          handleClose={() => setAccountDetailsModal(false)}
        />
      )}
    </Container>
  );
};
